import { render, staticRenderFns } from "./MicrophonesSettings.vue?vue&type=template&id=0165cfcd&scoped=true&lang=pug"
import script from "./MicrophonesSettings.vue?vue&type=script&lang=js"
export * from "./MicrophonesSettings.vue?vue&type=script&lang=js"
import style0 from "./MicrophonesSettings.vue?vue&type=style&index=0&id=0165cfcd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0165cfcd",
  null
  
)

export default component.exports